import {createSelector} from 'reselect';
import dateFormat from 'dateformat';

import parseUrlDateString from '@ibibo/date-utils/src/parseUrlDateString';

const thankYouSelector = state => state.thankyou;

const thankyouDataSelector = state => state.thankyou?.thankyouData;

export const thankYouDataSelector = createSelector(thankyouDataSelector, item => item);
export const IDSelector = createSelector(thankYouSelector, item => item?.id);

export const hotelDetailsSelector = createSelector(thankyouDataSelector, item => item.hotel_details);
export const roomDetailsSelector = createSelector(thankyouDataSelector, item => item.room_details);

export const checkinCheckoutSelector = createSelector(thankyouDataSelector, item => {
  const checkin = parseUrlDateString(item.room_details?.checkin_date);
  const checkout = parseUrlDateString(item.room_details?.checkout_date);

  return {
    checkinDate: checkin ? dateFormat(new Date(checkin), 'dd mmm') : '',
    checkoutDate: checkout ? dateFormat(new Date(checkout), 'dd mmm') : '',
    checkinTime: item.room_details?.checkin_time,
    checkoutTime: item.room_details?.checkout_time,
    nights: item.room_details?.nights
  };
});

export const guestSelector = createSelector(thankYouDataSelector, item => {
  const guests = item.room_details?.no_of_guests;
  const rooms = item.room_details?.no_of_rooms;
  const name = item?.pax_name;
  return {
    name,
    noOfGuests: `${guests} ${guests > 1 ? 'Guests' : 'Guest'}`,
    noOfRooms: `${rooms} ${rooms > 1 ? 'Rooms' : 'Room'}`,
  };
});

export const statusSelector = createSelector(thankyouDataSelector, item => {
  return {
    status: item?.status,
    statusFlag: item?.status_flag,
    header: item?.thank_you_text,
    subHeader: item?.thank_you_subtext,
    bookingId: item?.booking_id
  };
});

export const contactInfoSelector = createSelector(thankyouDataSelector, item => item?.contact_info || {});

export const priceInfoSelector = createSelector(thankyouDataSelector, item => item?.price_info || {});
export const fareBreakupSelector = createSelector(thankyouDataSelector, item => item?.fb_list || []);
